export const MAX_FILE_SIZE = 26214400;

export const ALLOWED_FILE_FORMATS =
  ".png,.txt,.xls,.doc,.pdf,.ppt,.jpg,.gif,.jpeg,.svg,.tif,.tiff,.docx,.rtf,.xlsx,.pptx,.eml,.csv,.msg,.dxf,.odt,.ods,.odp,.odg,.mp4,.mov,.avi,.wmv,.webm";

export enum FILE_FORMAT_ERRORS {
  MAX_FILE_SIZE = "max_file_size",
  INVALID_FILE_FORMAT = "invalid_file_format",
}
